import React from 'react';
import PropTypes from 'prop-types';

import DealCell from 'bundles/apex/deals/cell';
import DealValue from 'bundles/apex/deals/value';

export default function DealGroupTotals({ deals, onlyColumns, orderedColumns }) {
  if (deals.length === 1) {
    return null;
  }

  const totals = { count: 0, grossCommissionIncome: 0, transactionValue: 0 };
  for (const deal of deals) {
    totals.count++;
    totals.grossCommissionIncome += deal.grossCommissionIncome || 0;
    totals.transactionValue += deal.transactionValue || 0;
  }

  const columns = [];
  for (const column of orderedColumns) {
    let value;
    const key = column.key === 'displayName' ? 'count' : column.key;
    if (totals.hasOwnProperty(key)) {
      value = <DealValue name={key} value={totals[key]} />;

      if (key === 'count') {
        value = <React.Fragment>Total ({value})</React.Fragment>;
      }
    }

    columns.push(
      <DealCell key={column.key} name={column.key}>
        {value}
      </DealCell>
    );
  }

  return onlyColumns ? columns : <tr>{columns}</tr>;
}

DealGroupTotals.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.shape({
    grossCommissionAmount: PropTypes.number,
    transactionValue: PropTypes.number,
  })).isRequired,
  onlyColumns: PropTypes.bool,
  orderedColumns: PropTypes.array.isRequired,
};
